import styled from 'styled-components';

export const JobTitleCell = styled.div`
  padding: 8px 0;
`;
